<template>
	<div id="AssistantConfig" class="assistant-config">
		<div class="container">
			<div class="table-responsive">
				<table class="table table-sm table-hover table-12">
					<thead>
						<tr>
							<th class="text-center">ID</th>
							<th>Url</th>
							<th>Nombre</th>
							<th>Modelo</th>
							<th class="text-center">Creación</th>
							<th class="text-center">Ultima Modiciación</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in listOpenAIsFilter" :key="index" class="tr-list">
							<td class="text-center">{{ item.id }}</td>
							<td>{{ item.url }}</td>
							<td>{{ item.name }}</td>
							<td>{{ item.model }}</td>
							<td class="text-center">{{ item.created_at }}</td>
							<td class="text-center">{{ item.updated_at }}</td>
							<td class="text-right options-hidden text-muted">
								<router-link :to="'/assistant/' + item.id">
									<i class="far fa-edit" title="Editar"></i>
								</router-link>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
        </div>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import assistant from '@/mixins/generals/assistant.js'

export default {
	name: 'AssistantConfig',
	mixins: [axiosAction, errors, mixin, assistant],
	data() {
		return {
		}
	},
	components: {
	},
	computed: {
		listOpenAIsFilter() {
			return this.listOpenAIs
		}
	},
	methods: {
		initModuleLocal() {
			this.setTitleModule('Configuración del Asistente para iSystem4')
			this.setSubTitleModule('')
			this.getAssistantsLocal()
		},
		getAssistantsLocal() {
			this.getAllAssistants()
		},
		getAllAssistantsResultLocal(response) {},
		resultAxiosLocal(responseLocal, response) {
			switch(responseLocal) {
				case 'getAllAssistantsResult': this.getAllAssistantsResult(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
        },
	},
	mounted () {
		this.initModule()
	}
}

</script>

<style scoped lang="scss">
.tr-list {
	.options-hidden {
		i {
			visibility: hidden;
			cursor: pointer;
		}
	}
}

.tr-list:hover {
	.options-hidden {
		i {
			visibility: visible;
		}
	}

}
</style>